module.exports = __webpack_public_path__ + "static/media/abattoir-cover.57165bdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Abattoir/abattoir-cover.jpg
// module id = 586
// module chunks = 0